// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "img.image[data-v-1947d8b6] {\n  width: 170px;\n  margin: 0 auto 20px;\n}\n.firmador-select[data-v-1947d8b6] {\n  cursor: pointer;\n  padding: 20px 30px;\n  border-radius: 5px;\n  border: 1px solid #cacaca;\n}", ""]);
// Exports
module.exports = exports;
